import React from 'react';
import {Box, CircularProgress, Typography, keyframes} from '@mui/material';
import logo from '../../livezone_logo.png?inline';

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.75;
    transform: scale(0.97);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const shimmer = keyframes`
  0% {
    background-position: -200% center;
  }
  100% {
    background-position: 200% center;
  }
`;

const EventPageLoader: React.FC = () => (
  <Box
    sx={{
      position: 'fixed',
      inset: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 3,
      background: 'linear-gradient(160deg, #f8f9fb 0%, #eceef2 45%, #e4e5e6 100%)',
      zIndex: 2000
    }}
  >
    <Box
      component="img"
      src={logo}
      alt="LiveZone"
      sx={{
        width: {xs: 140, sm: 200},
        animation: `${pulse} 2s ease-in-out infinite`
      }}
    />

    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <CircularProgress
        size={56}
        thickness={3}
        sx={{
          color: 'primary.main',
          opacity: 0.2
        }}
      />
      <CircularProgress
        size={56}
        thickness={3}
        sx={{
          color: 'primary.main',
          position: 'absolute',
          left: 0
        }}
      />
    </Box>

    <Typography
      variant="body2"
      sx={{
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: '0.75rem',
        background: 'linear-gradient(90deg, #888 0%, #ff0066 50%, #888 100%)',
        backgroundSize: '200% auto',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        animation: `${fadeIn} 0.6s ease-out, ${shimmer} 2.4s linear 0.6s infinite`
      }}
    >
      Loading replay
    </Typography>
  </Box>
);

export default EventPageLoader;
